import { identity } from 'rxjs';
import { UserId } from '@business/entities/account';
import { ProjectId } from '@business/entities/project';
import { ProjectSectionResponse, ProjectStepResponse } from '@business/entities/project/ProjectSectionResponse';
import { Endpoint } from '../endpoint';
import { CompactSharedProjectResponse, SharedProjectResponse, SharedProjectId } from '@business/entities/sharedProject';
import { TenantIdentity } from '@business/entities/common';
import { TaskPriority } from '@business/constants/task';

export function fetchProjects() {
  return Endpoint.get<CompactSharedProjectResponse[]>(`@gc/shared-projects`);
}

export function fetchProject(identity: TenantIdentity, id: SharedProjectId) {
  return Endpoint.get<SharedProjectResponse>(`@gc/shared-project/project/${id}`, { identity });
}

export function toggleStep(identity: TenantIdentity, stepId: number, completeAll?: boolean) {
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/toggle-step/${stepId}`, { data: { completeAll }, identity });
}
/** Section **/
export function createSection(identity: TenantIdentity, id: ProjectId, name: string, tenantId?: string) {
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/section/${id}`, { identity, data: { name, tenantId, isPublic: true } });
}

export function updateSection(identity: TenantIdentity, id: string, name: string, tenantId?: string) {
  return Endpoint.patch<SharedProjectResponse>(`@gc/shared-project/section/${id}`, { identity, data: { name, tenantId } });
}

export function deleteSection(identity: TenantIdentity, id: string) {
  return Endpoint.delete<SharedProjectResponse>(`@gc/shared-project/section/${id}`, { identity });
}

export function duplicateSection(identity: TenantIdentity, id: string) {
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/duplicate-section/${id}`, { identity });
}

export function updateSectionClose(identity: TenantIdentity, sectionId: string, isClosed: boolean) {
  return Endpoint.post<void>(`@gc/shared-project/section-close/${sectionId}`, { data: { isClosed }, identity });
}

/** Step **/
export function fetchStep(identity: TenantIdentity, id: string) {
  return Endpoint.get<ProjectStepResponse>(`@gc/shared-project/step/${id}`, { identity });
}

export function createStep(identity: TenantIdentity, id: string, data: Partial<ProjectStepResponse>, parentStepId?: string) {
  data.parentId = parentStepId;
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/step/${id}`, { data, identity });
}

export function updateStep(identity: TenantIdentity, id: string, data: Partial<ProjectStepResponse>) {
  return Endpoint.patch<SharedProjectResponse>(`@gc/shared-project/step/${id}`, { data, identity });
}

export function duplicateStep(identity: TenantIdentity, id: string) {
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/duplicate-step/${id}`, { identity });
}

export function deleteStep(identity: TenantIdentity, id: string) {
  return Endpoint.delete<SharedProjectResponse>(`@gc/shared-project/step/${id}`, { identity });
}

export function sortSectionSteps(identity: TenantIdentity, ids: string[]) {
  return Endpoint.post<void>(`@gc/shared-project/sort-step`, { data: { ids }, identity });
}

export function assignSection(projectId: ProjectId, sectionId: string, users: UserId[]) {
  return Endpoint.post<ProjectSectionResponse[]>(`@gc/project/sections/section-assign/${sectionId}`, { data: { users, projectId } });
}

export function setProjectStepPriority(identity: TenantIdentity, stepId: string, priority: TaskPriority) {
  return Endpoint.post<ProjectSectionResponse[]>(`@gc/shared-project/set-project-step-priority/${stepId}`, { data: { priority }, identity });
}

export function orderTodos(identity: TenantIdentity, projectId: ProjectId, items: any) {
  return Endpoint.post<SharedProjectResponse>(`@gc/shared-project/order-todos/${projectId}`, { data: { items }, identity });
}

export function assignProjectStep(identity: TenantIdentity, stepId: string, data: string[]) {
  return Endpoint.post<ProjectSectionResponse[]>(`@gc/shared-project/assign-project-step/${stepId}`, { data: { data }, identity });
}
